import getRandomNumberFromId from '../getRandomNumberFromId/getRandomNumberFromId';

const defaultCoverPhotos = [
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_1.jpg`,
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_2.jpg`,
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_3.jpg`,
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_4.jpg`,
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_5.jpg`,
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_6.jpg`,
  `https://s3-eu-west-1.amazonaws.com/workey-images/project_image_7.jpg`,
];

export default id => {
  const randomNumberInRange = getRandomNumberFromId({ id, min: 0, max: 6 });
  return defaultCoverPhotos[randomNumberInRange];
};
